<template>
    <div class="container">
        <div class="d-felx justify-content-center align-items-center mb-3">
            <h2 class="text-center" style="color: white;">{{ department }}</h2>
        </div>  
        <hr>
        <div class="h-100 w-100 p-2 d-flex flex-column ">
            <div class="d-flex" id="navigation"> 
                <ul class="list-group list-group-flush nav-list">
                    <span  v-for="(nav_item,index) in data.nav" :key="index">
                            <li class="list-group-item nav-list-item" @click="scrollToBottom(nav_item)">
                                {{nav_item}}
                            </li>
                    </span>
                </ul>
            </div>
            <div class="text-center" v-if="isloading">
                        <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
            </div>
            <div class="main-div" v-html="data.response" v-else/>
        </div>
    </div>


</template>
<script>

export default {
    data(){
        return{
            department : 'DEPARTMENT NAME',
            data: '',
            isloading: false
            
        }
    },
    computed:{
        dept(){
            return this.$route.query.department
        }
    },
    methods: {
        async load(){
           
            await this.$axios.get(`departmentrm?dept=${this.dept}`)
            .then(res => {
                // console.log(res.data)
                this.department = res.data.dept_name
                this.data = res.data.response
            })
            this.isloading != this.isloading
        },
          scrollToElement(nav_item) {
            const el = this.$refs.scrollToMe;

            if (el) {
            // Use el.scrollIntoView() to instantly scroll to the element
            el.scrollIntoView(nav_item) ;
            el.scrollIntoView({behavior: 'smooth'});
            }
            console.log(el)
        },
        scrollToBottom(nav_item) {
            let element = document.getElementById(nav_item);
            element.scrollIntoView({behavior: "smooth", block: "start"});
        }
    },
    mounted(){
        this.load()
    },
    watch: {
        "dept" : function(){
          this.isloading != this.isloading
                this.load()
    
        }
    }
}
</script>
<style scoped>

.container{
    max-width: unset;
    overflow:auto;
    height: 100%;
    width: 100% !important;
    padding: 20px;
}

/* width */
.container::-webkit-scrollbar {
  width: 13px;

}
/* Track */
.container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px grey !important; 
  border-radius: 10px !important;
}
 
/* Handle */
.container::-webkit-scrollbar-thumb {
  background: lightgrey !important; 
  border-radius: 10px !important;

}

/* Handle on hover */
.container::-webkit-scrollbar-thumb:hover {
  background: grey !important; 
}

img{
        filter: blur(1px);
        -webkit-filter: blur(1px);
}

section{
    padding: 50px;
}

ul li {
    cursor: pointer;
}

div#navigation{
    
    position: fixed;
    z-index: 9999;
    right: 1.5%;
    top:20%;
}

ul.nav-list li.nav-list-item{
    background: white;
    opacity: 0.6;
    color: black;
    margin: 0 3px 0 3px;
  
}


</style>
